import { AVANTIO_ACCOMMODATION_ALREADY_LINKED_ERROR } from "./error-codes.constants";

export class AvantioAccommodationAlreadyLinkedError extends Error {
  code: string;
  conflictingRoomName?: string;

  constructor(conflictingRoomName?: string) {
    super("Avantio accommodation already linked error");
    this.name = "AvantioAccommodationAlreadyLinkedError";
    this.code = AVANTIO_ACCOMMODATION_ALREADY_LINKED_ERROR;
    this.conflictingRoomName = conflictingRoomName;
  }
}
